import { Tooltip } from 'recharts'
import type { ComponentProps, ReactNode } from 'react'

type RechartsTooltipProps = ComponentProps<typeof Tooltip>
type FormatterArgs = Parameters<NonNullable<RechartsTooltipProps['formatter']>>
type LabelFormatterArgs = Parameters<NonNullable<RechartsTooltipProps['labelFormatter']>>

/**
 * recharts 3 widened the Tooltip formatter `value`/`label` to `ValueType`; our
 * charts are all numeric, so narrow to `number` and bridge with one cast below.
 */
export type ChartTooltipProps = Omit<RechartsTooltipProps, 'formatter' | 'labelFormatter'> & {
  formatter?: (
    value: number,
    name: string,
    item: FormatterArgs[2],
    index: FormatterArgs[3],
    payload: FormatterArgs[4]
  ) => ReactNode | [ReactNode, ReactNode] | null
  labelFormatter?: (label: number, payload: LabelFormatterArgs[1]) => ReactNode
}

export function ChartTooltip(props: ChartTooltipProps) {
  return <Tooltip {...(props as RechartsTooltipProps)} />
}
